module.exports = __webpack_public_path__ + "static/media/UN-09.60278168.jpg";